var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPostLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.9062 3.125C12.293 3.125 10.8805 3.81875 10 4.99141C9.11953 3.81875 7.70703 3.125 6.09375 3.125C4.80955 3.12645 3.57837 3.63723 2.6703 4.5453C1.76223 5.45337 1.25145 6.68455 1.25 7.96875C1.25 13.4375 9.35859 17.8641 9.70391 18.0469C9.79492 18.0958 9.89665 18.1215 10 18.1215C10.1033 18.1215 10.2051 18.0958 10.2961 18.0469C10.6414 17.8641 18.75 13.4375 18.75 7.96875C18.7486 6.68455 18.2378 5.45337 17.3297 4.5453C16.4216 3.63723 15.1904 3.12645 13.9062 3.125ZM10 16.7812C8.57344 15.95 2.5 12.1633 2.5 7.96875C2.50124 7.01601 2.88026 6.10265 3.55396 5.42896C4.22765 4.75526 5.14101 4.37624 6.09375 4.375C7.61328 4.375 8.88906 5.18438 9.42188 6.48438C9.46896 6.59901 9.54907 6.69705 9.65201 6.76605C9.75494 6.83505 9.87607 6.8719 10 6.8719C10.1239 6.8719 10.2451 6.83505 10.348 6.76605C10.4509 6.69705 10.531 6.59901 10.5781 6.48438C11.1109 5.18203 12.3867 4.375 13.9062 4.375C14.859 4.37624 15.7724 4.75526 16.446 5.42896C17.1197 6.10265 17.4988 7.01601 17.5 7.96875C17.5 12.157 11.425 15.9492 10 16.7812Z",
    fill: "#424242"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPostLike);
export default __webpack_public_path__ + "static/media/icon_post_like.8ae66d42dc4ee6351e438bac9cbe48fd.svg";
export { ForwardRef as ReactComponent };